import { Card, Input, Select } from "@rumbledirect/ui";
import type { ImageCapturePage } from "@rumble-it/common-lib/types/models/ImageCapture.interface";
import type { UseMutationResult } from "@tanstack/react-query";
import { Form, InputNumber, message } from "antd";
import { useMemo } from "react";

interface ImageCapturePageFormCardProps {
  title?: string;
  buttonText?: string;
  loading?: boolean;
  initialValues?: ImageCapturePage;
  pageTypes: Array<{ label: string; value: string }>;
  mutation: UseMutationResult<null, Error, ImageCapturePage, unknown>;
}

export const ImageCapturePageFormCard = ({
  title = "Pagina toevoegen",
  loading,
  initialValues,
  pageTypes,
}: ImageCapturePageFormCardProps) => {
  const [form] = Form.useForm();

  const normalizedInitials = useMemo(() => {
    if (!initialValues) return undefined;
    return {
      ...initialValues,
      type:
        typeof initialValues.type === "object"
          ? (initialValues.type as { "@id": string })["@id"]
          : initialValues.type,
      settings:
        typeof initialValues.settings === "string"
          ? initialValues.settings
          : JSON.stringify(initialValues.settings ?? {}, null, 2),
    };
  }, [initialValues]);

  const handleFinish = async (
    values: Partial<ImageCapturePage> & { settings?: string },
  ) => {
    // Parse settings to object if it's a string
    let _parsedSettings: unknown = values.settings;
    if (typeof values.settings === "string" && values.settings.trim() !== "") {
      try {
        _parsedSettings = JSON.parse(values.settings as string);
      } catch {
        message.error("Instellingen bevatten ongeldige JSON");
        return;
      }
    }
  };

  return (
    <Card title={title} loading={loading}>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={normalizedInitials}
      >
        <Form.Item
          label="Titel"
          name="title"
          rules={[{ required: true, message: "Titel is verplicht" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Type pagina"
          name="type"
          rules={[{ required: true, message: "Type is verplicht" }]}
        >
          <Select
            options={pageTypes}
            placeholder="Selecteer type"
            showSearch
            optionFilterProp="label"
          />
        </Form.Item>
        <Form.Item
          label="Prioriteit"
          name="priority"
          rules={[{ required: true, message: "Prioriteit is verplicht" }]}
        >
          <InputNumber className="w-full" />
        </Form.Item>
        <Form.Item label="Instellingen (JSON)" name="settings">
          <Input.TextArea
            rows={12}
            placeholder={'{\n  "isImageRequired": true\n}'}
          />
        </Form.Item>
      </Form>
    </Card>
  );
};
